<div class="container">
  <div class="panel">
    <a
      [href]="LINKS.googleMapsAddress"
      target="_blank"
    >
      <p class="panel__text-line">MedCare625 Helios Avenue, San Francisco, CA 94110, USA</p>
    </a>
    <mdcr-button
      class="text-medium"
      [label]="'email@medcare.com'"
      mdcrTooltip
      message="Copy to clipboard"
      messageOnClick="Copied"
      [changeStatusOnClick]="true"
      [position]="TOOLTIP_POSITION.right"
      (buttonClick)="copyToClipboard('email@medcare.com')"
    />
    <mdcr-button
      class="text-medium"
      [label]="'+91-80-268-2800'"
      mdcrTooltip
      message="Copy to clipboard"
      messageOnClick="Copied"
      [changeStatusOnClick]="true"
      [position]="TOOLTIP_POSITION.right"
      (buttonClick)="copyToClipboard('+91-80-268-2800')"
    />
  </div>

  <div class="panel panel--fixed-width">
    <div class="panel__content-icons">
      <a
        [href]="LINKS.instagram"
        target="_blank"
      >
        <img
          alt="Instagram"
          height="24"
          width="24"
          [src]="SVG.instagram"
        />
      </a>
      <a
        [href]="LINKS.x"
        target="_blank"
      >
        <img
          alt="X"
          height="24"
          width="24"
          [src]="SVG.x"
        />
      </a>
      <a
        [href]="LINKS.facebook"
        target="_blank"
      >
        <img
          alt="Facebook"
          height="24"
          width="24"
          [src]="SVG.facebook"
        />
      </a>
    </div>
  </div>
</div>
